import { TicketIcon } from "@heroicons/react/24/outline"
import { Button } from "../ui/button"
import { cn } from "../../lib/utils"

interface EmptyStateProps {
  icon?: React.ReactNode
  title?: string
  message: string
  action?: {
    label: string
    onClick: () => void
  }
  className?: string
}

export function EmptyState({ 
  icon, 
  title, 
  message, 
  action,
  className 
}: EmptyStateProps) {
  return (
    <div className={cn("flex flex-col items-center justify-center py-12 px-4", className)}>
      {icon || <TicketIcon className="h-12 w-12 text-muted-foreground mb-4" />}
      {title && (
        <h3 className="text-sm font-medium text-foreground mb-2">{title}</h3>
      )}
      <p className="text-sm text-muted-foreground text-center mb-4">{message}</p>
      {action && (
        <Button onClick={action.onClick} variant="default" size="sm">
          {action.label}
        </Button>
      )}
    </div>
  )
}

